import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Caption from 'LuxKit/Typography/Caption'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'

const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.default.one};
  border: 1px solid ${props => props.theme.palette.neutral.default.eight};

  &.variant-small {
    width: ${rem(28)};
    height: ${rem(28)};
  }

  &.variant-medium {
    width: ${rem(36)};
    height: ${rem(36)};
  }
`

interface Props {
  variant?: 'small' | 'medium'
  cartMember: App.MultiCartMember
}

function SharedCartsUserAvatar(props: Props) {
  const { cartMember, variant = 'small' } = props

  const splittedName = cartMember.fullName?.split(' ') || []
  const firstName = splittedName[0]
  const lastName = splittedName[splittedName.length - 1]

  const initials = useMemo(() => {
    if (!firstName) return null
    return `${firstName[0] || ''}${lastName?.[0] || ''}`.toUpperCase()
  }, [firstName, lastName])

  return (
    <Avatar className={`variant-${variant}`}>
      {!initials && <LineUserIcon colour="neutral-eight" size="XS" />}
      {initials && <Caption variant={variant} weight="bold" colour="neutral-eight">{initials}</Caption>}
    </Avatar>
  )
}

export default SharedCartsUserAvatar
